import events from '@/services/events';



export default {
  namespaced: true,

  state: {
    modals: []
  },

  getters: {
    currentlyOpenModal({ modals }) {
      if (modals.length === 0) {
        return null;
      }

      return modals[modals.length - 1];
    },

    modals(state) {
      return state.modals;
    }
  },

  actions: {
    closeAllModals({ commit }) {
      commit('CLOSE_ALL_MODALS');
    },

    closeModal({ commit }, name) {
      commit('CLOSE_MODAL', name);
    },

    lockModal({ commit }, name) {
      commit('SET_MODAL_LOCK', {
        name,
        isLocked: true
      });
    },

    async modalIsOpen({ getters }) {
      return !!getters.currentlyOpenModal;
    },

    openModal({ commit }, options) {
      if (options.closeModal) {
        commit('CLOSE_MODAL', options.closeModal);
      }

      commit('OPEN_MODAL', options);

      events.emit('modals:open');
    },

    unlockModal({ commit }, name) {
      commit('SET_MODAL_LOCK', {
        name,
        isLocked: false
      });
    }
  },

  mutations: {
    CLOSE_ALL_MODALS(state) {
      state.modals = [];
    },

    CLOSE_MODAL(state, name) {
      state.modals = state.modals.filter(modal => modal.name !== name);
    },

    OPEN_MODAL(state, { data, name, isLocked = false, isRequired = false }) {
      // NOTE: If this modal was already open, we move it to the end of the array

      const modals = state.modals.filter(modal => modal.name !== name);

      modals.push({
        data,
        isLocked,
        isRequired,
        name
      });

      state.modals = modals;
    },

    SET_MODAL_LOCK(state, options) {
      const modal = state.modals.find(m => m.name === options.name);

      if (modal) {
        modal.isLocked = options.isLocked;
      }
    }
  }
};
